import { createStoreChunk } from '@core/store'

export type TAuthType = 'email' | 'google' | 'facebook' | null

/**
 * Last auth method used, kept for analytics attribution — replaces audio-web's raw localStorage
 * `AUTH_TYPE_KEY`.
 */

type TAuthTypeState = { authType: TAuthType }

export const authTypeStore = createStoreChunk<TAuthTypeState>('authType')({
    persist: { localStorage: ['authType'] },
    initialState: { authType: null },
})
